// import { createCheckout, updateCheckout } from "./Shopify";

//util function to figure out if the left and right side are stacked (vertical) or side-by-side (horizontal)
export function checkColumnMode(size, left, right, sizes) {
	let availSizes = sizes.slice(0, sizes.indexOf(size) + 1).reverse();
	const leftSizeIs = parseInt(getSize(left, availSizes));
	const rightSizeIs = parseInt(getSize(right, availSizes));

	function getSize(side, availSizes) {
		let sizeIs;
		let index = 0;
		while (sizeIs === undefined && index < availSizes.length) {
			sizeIs = side[availSizes[index]];
			if (typeof sizeIs === "object") {
				sizeIs = sizeIs["span"] + sizeIs["offset"];
			}
			index++;
		}
		if (!sizeIs) sizeIs = 12;
		return sizeIs;
	}

	return leftSizeIs + rightSizeIs > 12;
}

export function switchProgramName(programName) {
	switch (programName) {
		case "aapmr":
			return "AAPM&R";
		case "aap":
			return "AAP";
		case "acp":
			return "ACP";
		case "gha":
			return "GHA";
		case "healogics":
			return "Healogics";
		case "nachc":
			return "NACHC";

		default:
			return "Program";
	}
}

export async function promptForPassword(setAaplStagePass) {
	const password = await prompt("Please Enter Password.");
	if (password === process.env.AAPL_TEST_PASSWORD) {
		window.localStorage.setItem("isAAPLEmployee", process.env.AAPL_TEST_PASSWORD);
		setAaplStagePass(true);
	} else {
		await promptForPassword(setAaplStagePass);
	}
}

export function checkLocalStoreForStaging() {
	if (typeof window == "undefined") return true;
	if (process.env.APP_ENV == "production") return true;

	const isAAPLEmployee = window.localStorage.getItem("isAAPLEmployee");
	if (isAAPLEmployee === process.env.AAPL_TEST_PASSWORD) {
		return true;
	}
	return false;
}

export function checkIsFallInstitute(name) {
	return name?.includes("Fall Institute");
}

export function checkIsInPersonContentfulName(name) {
	return name?.includes("In-Person");
}

export function checkIsPreConfCourse(name) {
	return name?.includes("Pre-Conference Course");
}
export function checkIsALC(name) {
	return name?.includes("Annual Leadership Conference") && !name.includes("Vanguard") && !checkIsPreConfCourse(name);
}
export function checkIsGalaDinner(name) {
	return name?.includes("Gala");
}
export function calcMemberPrice(item = {}, user = {}, opts = {}) {
	if (!user) user = {};
	let discount = user?.discount;

	//catch edge case when no price is identified (business error)
	if (item?.price === undefined) return "N/A";

	const { standard } = opts;
	//opts.standard is used to show a non-member a sample of a standard member discount,
	if (standard) discount = 0.85;
	//if no discount is found, discount = 1 is no discount.
	if (!discount) discount = 1;

	//if variant specific, then show the price as is
	if (item.programSpecificVariant) {
		return item.price;
	}
	//check for special member pricing for a user who is a member
	if (user.isMember && item.specialMemberPrice) {
		return item.specialMemberPrice;
	}
	//if not a member, and showing non-member what could be their member price
	if (standard && item.specialMemberPrice) {
		return item.specialMemberPrice;
	}

	return item.price * discount;
}

export function getVariantData({ variantId, productData, value, deliveryFormat }) {
	if (!productData.fields.variants) {
		console.error("this product has no variants");
		return false;
	}

	let productVariants = [];
	if (deliveryFormat) {
		productVariants = productData.fields.variants.filter(
			(_variant) => _variant.fields.deliveryFormat === deliveryFormat
		);
	}
	if (variantId) {
		productVariants = productData.fields.variants.find((_variant) => _variant.fields.variantId === variantId);
	}
	if (value !== undefined) {
		return productVariants?.fields[value];
	}

	//send the whole variant object, add product data also
	if (!value) {
		//if there are several variants, then sort the options
		if (Array.isArray(productVariants) && productVariants.length >= 1) {
			//sort Subscription and journal options
			if (
				productData.fields.productType === "Other Subscription" ||
				productData.fields.productType === "Journal"
			) {
				productVariants = sortOptions(productVariants, "option");
			} else if (deliveryFormat === "Hybrid Online" || deliveryFormat === "In-Online") {
				productVariants = productVariants.sort(
					(a, b) =>
						new Date(a.fields.courseStartDate).getTime() - new Date(b.fields.courseStartDate).getTime()
				);
			}
			productVariants.forEach((product) => {
				//remove variants from the product data to avoid circular refs
				const tempProduct = { ...productData.fields };
				delete tempProduct.variants;
				product.fields = { ...tempProduct, ...product.fields };
			});
			return productVariants;
		} else if (!productVariants) {
			return productVariants;
		} else {
			const tempProduct = { ...productData.fields };
			delete tempProduct.variants;
			productVariants.fields = {
				...tempProduct,
				...(productVariants?.fields && {
					...productVariants.fields,
				}),
			};
			return productVariants;
		}

		return productVariants;
	}
}

export function getTimeZoneAbbreviation(timezone) {
	switch (timezone) {
		case "America/Phoenix":
			return "MST";
		case "America/New_York":
			return "ET";
		case "America/Chicago":
			return "CT";
		case "America/Los_Angeles":
			return "PT";
		case "America/Denver":
			return "MT";

		default:
			return "";
	}
}

export function valueOrDefault(value, browserDefault) {
	if (value === undefined || value === browserDefault) {
		return false;
	} else {
		return value;
	}
}

export function getImgDimensions({ w, h, fields }) {
	let image = fields?.media?.fields?.file?.details?.image;
	if (!image) {
		return {};
	}
	const { width, height } = image;
	if (!width || !height) {
		//this is going to fail
		console.error("Missing width or height", width, height);
	}

	if (w && !h) {
		h = Math.floor(w / (width / height));
	} else if (h && !w) {
		w = Math.floor((width / height) * h);
	}

	return { w, h };
}

export function getScreenSize() {
	if (typeof window === "undefined") return "xs";

	// Bootstrap 5 breakpoints
	if (min(1400)) {
		return "xxl"; // ≥1400px
	} else if (min(1200)) {
		return "xl"; // ≥1200px
	} else if (min(992)) {
		return "lg"; // ≥992px
	} else if (min(768)) {
		return "md"; // ≥768px
	} else if (min(576)) {
		return "sm"; // ≥576px
	} else {
		return "xs"; // <576px
	}

	function min(size) {
		return window.matchMedia(`(min-width: ${size}px)`).matches;
	}
}

export function sizeEqualOrLessThan(_size) {
	const size = getScreenSize();
	if (_size === "xxl") {
		//all sizes are less than or equal xxl
		return true;
	} else if (_size === "xl") {
		//all sizes except xxl are less than or equal xl
		return size !== "xxl";
	} else if (_size === "lg") {
		//all sizes except xxl, and xl
		return size !== "xxl" && size !== "xl";
	} else if (_size === "md") {
		return size !== "xxl" && size !== "xl" && size !== "lg";
	} else if (_size === "sm") {
		return size !== "xxl" && size !== "xl" && size !== "lg" && size !== "md";
	} else if (_size === "xs") {
		return size !== "xxl" && size !== "xl" && size !== "lg" && size !== "md" && size !== "sm";
	}
}

export function productIncludedInMembership(product) {
	//some items maybe included in membership, currently it's just PLJ
	const name = product?.fields.internalName;
	if (!name) return false;

	if (name.toLowerCase().includes("physician leadership journal")) {
		return true;
	}
	return false;
}

//Trim all fields that are not in the selectAll array
export function trimFields(entry, selectAll) {
	Object.keys(entry.fields).forEach((fieldName) => {
		const isSelected = selectAll.find((select) => {
			return fieldName === select;
		});

		if (!isSelected) {
			delete entry.fields[fieldName];
		}
	});

	return entry;
}

//sort by option
export function sortOptions(variants, sortBy) {
	const variantSortOrder = ["monthly", "1-Year", "2-Year", "3-Year", undefined];
	const sortedVariants = variants.sort((a, b) => {
		const aVal = variantSortOrder.indexOf(a.fields[sortBy]);
		const bVal = variantSortOrder.indexOf(b.fields[sortBy]);
		return aVal - bVal;
	});
	return sortedVariants;
}

export function sortVariantDeliverFormat(variants) {
	// const deliveryFormatSortOrder = [
	// 	"Self-Study",
	// 	"Hybrid Online",
	// 	"In-Person",
	// 	"Book",
	// 	"eBook",
	// 	"Subscription",
	// 	"Webinar",
	// 	undefined,
	// ];

	//all selfStudy // doesn't need sorting
	let allSelfStudy = variants.filter((v) => v.fields.deliveryFormat === "Self-Study");

	//all hybrid // sorted by date offered
	let allHybrid = variants.filter((v) => v.fields.deliveryFormat === "Hybrid Online");
	allHybrid = allHybrid.sort((a, b) => {
		return new Date(a.fields.courseStartDate).getTime() - new Date(b.fields.courseStartDate).getTime();
	});
	//all in person // sorted by date offered
	let allInPerson = variants.filter((v) => v.fields.deliveryFormat === "In-Person");
	allInPerson = allInPerson.sort((a, b) => {
		return new Date(a.fields.courseStartDate).getTime() - new Date(b.fields.courseStartDate).getTime();
	});
	//all book // no sorting needed
	let allBook = variants.filter((v) => v.fields.deliveryFormat === "Book");
	let allPaperback = variants.filter(
		(v) => v.fields.deliveryFormat === "Book" || v.fields.deliveryFormat === "Paperback"
	);
	//all ebook // no sorting needed
	let allEBook = variants.filter((v) => v.fields.deliveryFormat === "eBook");

	//all subscription // no sorting needed
	let allSubs = variants.filter((v) => v.fields.deliveryFormat === "Subscription");

	//all subscription // no sorting needed
	let allJournals = variants.filter((v) => v.fields.deliveryFormat === "Online");
	//all Webinar // no sorting needed
	let allWebinars = variants.filter((v) => v.fields.deliveryFormat === "Webinar");
	//Academy // no sorting needed
	let allAcademy = variants.filter((v) => v.fields.deliveryFormat === "Academy");

	return [
		...allSelfStudy,
		...allHybrid,
		...allInPerson,
		...allBook,
		...allPaperback,
		...allEBook,
		...allJournals,
		...allSubs,
		...allWebinars,
		...allAcademy,
	];
}

export function saveLocalData(cart, checkoutId, checkoutUrl) {
	localStorage.setItem(process.env.CART_LOCAL_STORAGE_NAME, JSON.stringify([cart, checkoutId, checkoutUrl]));
}

function getLocalData() {
	return JSON.parse(localStorage.getItem(process.env.CART_LOCAL_STORAGE_NAME));
}

export function setLocalData(setCart, setCheckoutId, setCheckoutUrl) {
	const localData = getLocalData();

	if (localData) {
		if (Array.isArray(localData[0])) {
			setCart([...localData[0]]);
		} else {
			setCart([localData[0]]);
		}
		setCheckoutId(localData[1]);
		setCheckoutUrl(localData[2]);
	}
}

export function getCartSubTotal(cart) {
	if (cart.length === 0) {
		return 0;
	} else {
		let totalPrice = 0;
		cart.forEach((item) => (totalPrice += parseInt(item.variantQuantity) * parseFloat(item.variantPrice)));
		return Math.round(totalPrice * 100) / 100;
	}
}

export function parseStartEndDates(start, end, timeZone) {
	let startTime, endTime;
	// if (timeZone) {//
	// 	startTime = new Date(new Date(start).toLocaleString("en-US", { timeZone })).getTime();

	// 	endTime = new Date(new Date(end).toLocaleString("en-US", { timeZone })).getTime();
	// } else {
	startTime = new Date(new Date(start).toUTCString()).getTime();
	endTime = new Date(new Date(end).toUTCString()).getTime();
	const timeDiff = endTime - startTime;
	const day = 1000 * 60 * 60 * 24;
	const days = timeDiff / day;
	const dates = [];
	for (let x = 0; x <= days; x++) {
		dates.push(parseDate(new Date(startTime + day * x).toISOString(), timeZone));
	}
	return dates;
}

export function formatCourseStartEndDates({ startDate, endDate }) {
	// const { startDate, endDate } = course;
	const courseStartDate = `${startDate.monthNumber}/${startDate.dayOfMonth}`;
	let courseEndDate = `${endDate.monthNumber}/${endDate.dayOfMonth}`;
	let courseStartTime = `${startDate.hours}${startDate.minutes !== "00" ? `:${startDate.minutes}` : ""}${
		startDate.amPm !== endDate.amPm ? startDate.amPm : ""
	}`;
	let courseEndTime = `${endDate.hours}${endDate.minutes !== "00" ? `:${endDate.minutes}` : ""}${endDate.amPm}`;
	let courseDates, courseTimes;
	if (courseStartDate === courseEndDate) {
		courseDates = `${courseStartDate}, ${`${courseStartTime} - ${courseEndTime}`}`;
	} else {
		courseDates = `${courseStartDate} - ${courseEndDate}`;
	}
	return { courseDates };
}

export function checkIsPromoted(
	serverStartDate,
	serverEndDate,
	browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
) {
	if (!serverStartDate || !serverEndDate) return;
	// Add time components to make start date the beginning of the day (UTC)
	// and end date the end of the day (UTC)
	const startDate = new Date(serverStartDate + "T00:00:00Z");
	const endDate = new Date(serverEndDate + "T23:59:59.999Z");

	// Get current date/time in the specified timezone
	const formatter = new Intl.DateTimeFormat("en-US", {
		timeZone: browserTimezone,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: false,
	});

	// Get current time
	const now = new Date();

	// Get timestamps for comparison
	const currentTimestamp = now.getTime();
	const startTimestamp = startDate.getTime();
	const endTimestamp = endDate.getTime();

	// Helper function to format dates for debugging
	const formatDate = (date) => {
		return new Intl.DateTimeFormat("en-US", {
			timeZone: browserTimezone,
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour12: false,
		})
			.format(date)
			.split(",")[0];
	};

	const formatDateTime = (date) => {
		return formatter.format(date).replace(",", "");
	};

	// const result = {
	// 	isInRange: currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp,
	// 	debug: {
	// 		userDateTime: formatDateTime(now),
	// 		userDate: formatDate(now),
	// 		startDate: formatDate(startDate),
	// 		endDate: formatDate(endDate),
	// 		timezone: browserTimezone,
	// 	},
	// };

	return currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp;
}

export function parseDate(date, timeZone) {
	if (!date) return {};
	let dayOfWeek, dayOfMonth, month, year, hours, minutes, amPm;
	if (timeZone && timeZone !== "Remote") {
		dayOfWeek = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getDay();
		dayOfMonth = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getDate();
		month = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getMonth();
		year = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getFullYear();
		hours = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getHours();
		minutes = new Date(new Date(date).toLocaleString("en-US", { timeZone })).getMinutes();
	} else {
		//works for parsing dates such as "2024-06-09T06:30"
		if (date.includes("T") && !date.includes("Z")) {
			dayOfWeek = new Date(date).getDay();
			dayOfMonth = new Date(date).getDate();
			month = new Date(date).getMonth();
			year = new Date(date).getFullYear();
			hours = new Date(date).getHours();
			minutes = new Date(date).getMinutes();
		} else {
			//works for parsing dates such as "2024-03-31T00:00:00.000Z"
			dayOfWeek = new Date(date).getUTCDay();
			dayOfMonth = new Date(date).getUTCDate();
			month = new Date(date).getUTCMonth();
			year = new Date(date).getUTCFullYear();
			hours = new Date(date).getHours();
			minutes = new Date(date).getMinutes();
		}
	}
	if (hours === 0) {
		//handle midnight
		hours = 12;
		amPm = "am";
	} else if (hours == 12) {
		//handle noon
		amPm = "pm";
	} else if (hours > 12) {
		//handle afternoon and hours over 12
		amPm = "pm";
		hours = hours - 12;
	} else {
		//else set am
		amPm = "am";
	}
	if (minutes.toString().length === 1) {
		minutes = `0${minutes}`;
	}

	function switchDayOfWeek(day) {
		switch (day) {
			case 0:
				return "Sunday";
			case 1:
				return "Monday";
			case 2:
				return "Tuesday";
			case 3:
				return "Wednesday";
			case 4:
				return "Thursday";
			case 5:
				return "Friday";
			case 6:
				return "Saturday";
			default:
				console.error(`Error parsing Day of the week for ${day}`);
				return "";
		}
	}

	function switchMonth(month) {
		switch (month) {
			case 0:
				return "Jan";
			case 1:
				return "Feb";
			case 2:
				return "Mar";
			case 3:
				return "Apr";
			case 4:
				return "May";
			case 5:
				return "June";
			case 6:
				return "July";
			case 7:
				return "Aug";
			case 8:
				return "Sept";
			case 9:
				return "Oct";
			case 10:
				return "Nov";
			case 11:
				return "Dec";
			default:
				console.error(`Error parsing Month for ${month}`);
				return "";
		}
	}

	function switchFullMonthName(month) {
		switch (month) {
			case 0:
				return "January";
			case 1:
				return "February";
			case 2:
				return "March";
			case 3:
				return "April";
			case 4:
				return "May";
			case 5:
				return "June";
			case 6:
				return "July";
			case 7:
				return "August";
			case 8:
				return "September";
			case 9:
				return "October";
			case 10:
				return "November";
			case 11:
				return "December";
			default:
				console.error(`Error parsing Month for ${month}`);
				return "";
		}
	}

	return {
		dayOfWeek: switchDayOfWeek(dayOfWeek),
		dayOfMonth,
		month: switchMonth(month),
		fullMonthName: switchFullMonthName(month),
		year,
		monthNumber: month + 1,
		hours,
		minutes,
		amPm,
	};
}

export function trimDescription(description, max) {
	// if (showMore) return description;
	const maxDescLength = max || 250;
	if (description.length > maxDescLength) {
		return `${description.slice(0, maxDescLength)}...`;
	} else return description;
}

export function trimJournalEditionTitle(title) {
	title = title.replace("PLJ -", "");
	title = title.replace("JMPM -", "");
	title = title.replace("Fast Practice -", "");
	title = title.trim();
	return title;
}

export function encodeJournalEditionTitle(title) {
	title = title.replace("/", "-");
	title = title.replace(" ", "-");

	return title;
}

export function getPodcastCardHref(fields = {}) {
	const slug = fields.slug;
	const podcastWebsite = fields.podcast?.podcastWebsite;
	if (!slug) {
		return `https://www.soundpractice.com/`;
	}
	return `${podcastWebsite}e/${slug}`;
}
export function getArticleCardHref(fields) {
	const { doiPrefix, doiSuffix, canonicalUrl } = fields;

	if (doiPrefix?.prefix && doiSuffix) {
		return `/articles/doi/${doiPrefix.prefix}/${doiSuffix}`;
	} else {
		return `/articles/${canonicalUrl}`;
	}
}

export function getPressReleaseHref(fields) {
	const { slug } = fields;

	return `/about/press-room/${slug}`;
}

export function getJournalBadgeColor(journal) {
	if (!journal) return;
	if (journal.includes("PLJ") || journal.includes("Physician Leadership Journal")) {
		return "lightBlue";
	} else if (journal.includes("Medical Practice Management") || journal.includes("JMPM")) {
		return "red";
	} else if (journal.includes("Healthcare Administration Leadership") || journal.includes("HALMJ")) {
		return "green";
	}
}

export function getReturnLinkDetails(productData, router) {
	// console.log(productData);
	const { productType } = productData?.fields;
	let productsLink, linkText;

	if (productType === "Webinar") {
		productsLink = "/webinars";
		linkText = "Webinars";
	} else if (productType === "Course") {
		//check possible previous route
		productsLink = "/education/courses";
		linkText = "Courses";
	} else if (productType === "Book") {
		//check possible previous route
		productsLink = "/publications/books";
		linkText = "Books";
	} else if (productType === "Journal" || productType === "Subscription") {
		//check possible previous route
		productsLink = "/publications/subscriptions";
		linkText = "Subscriptions";
	}
	return {
		productsLink,
		linkText,
	};
}
/**
 * This href needs to point to the [product-slug].js file
 */
export function getProductHref(fields) {
	if (!fields) return "#"; //prevent a crash
	const productType = fields?.productType?.toLowerCase();

	const { programName, programSpecificVariant, variantId } = fields;

	let queryParams = "";
	if (variantId) {
		queryParams += `v=${variantId}&`;
	}
	if (programSpecificVariant && programName) {
		queryParams += `pn=${programName}&`;
	}

	switch (productType) {
		case "assessment":
			return `/store/assessments/${fields.slug}${queryParams ? `?${queryParams}` : ""}`;
		case "book":
			return `/publications/books/${fields.slug}${queryParams ? `?${queryParams}` : ""}`;

		case "course":
			return `/education/course/${fields.slug}${queryParams ? `?${queryParams}` : ""}`;

		case "other subscription":
		case "journal":
			return `/publications/subscriptions/${fields.slug}${queryParams ? `?${queryParams}` : ""}`;

		case "webinar":
			return `/webinar/${fields.slug}${queryParams ? `?${queryParams}` : ""}`;

		default:
			return "#";
			break;
	}
}

export const screenSizes = ["xs", "sm", "md", "lg", "xl", "xxl"];

export const productCardSelectFields = [
	"metaDescription",
	"shortDescription",
	"isNew",
	"slug",
	"productType",
	"productMedia",
	"title",
	"cpeCoreElective",
	"mastersCoreElective",
	"bookAuthor",
];

//function that reduces a list of variants down to essential data for productcard display
export function reduceVariantsForProductCardDisplay(variants = []) {
	//transform data to be Products with Variants
	let products = variants.reduce((acc, variant) => {
		//get the product
		const product = variant.fields.product;
		if (!product) {
			return acc;
		}
		const productSlug = product?.fields?.slug;
		if (!productSlug) {
			return acc;
		}
		if (!acc[productSlug]) {
			product.variants = [];
			// start Reducing data sent to client
			product.sys = {
				contentType: product.sys.contentType,
				id: product.sys.id,
			};
			product.fields = productCardSelectFields.reduce((acc, field) => {
				const value = product.fields[field];
				if (value) {
					acc[field] = value;
				}
				return acc;
			}, {});
			//end Reducing data sent to client
			acc[productSlug] = product;
		}
		acc[productSlug].variants.push(variant);
		return acc;
	}, {});
	//find the lowest price variant for each product and add price/cme to it, then return
	products = Object.keys(products).map((slug) => {
		const product = products[slug];
		let variants = product.variants;
		variants = variants.sort((a, b) => a.fields.price - b.fields.price);

		variants = variants.sort(
			(a, b) => new Date(a.fields.courseStartDate).getTime() - new Date(b.fields.courseStartDate).getTime()
		);

		const variant = variants[0];
		if (variant.fields.price !== undefined) {
			product.fields.price = variant.fields.price;
		}
		if (variant.fields.specialMemberPrice !== undefined) {
			product.fields.specialMemberPrice = variant.fields.specialMemberPrice;
		}
		if (variant.fields.maxCme !== undefined) {
			product.fields.maxCme = variant.fields.maxCme;
		}
		//add a variantId onto the base product to tell the product card which specific variant to link to
		if (variant.fields.variantId !== undefined) {
			product.fields.variantId = variant.fields.variantId;
		}
		if (variant.fields.programSpecificVariant !== undefined) {
			product.fields.programSpecificVariant = variant.fields.programSpecificVariant;
		}
		if (variant.fields.programName !== undefined) {
			product.fields.programName = variant.fields.programName;
		}
		if (variant.fields.sku !== undefined) {
			product.fields.sku = variant.fields.sku;
		}
		if (variant.fields.shortDescription !== undefined) {
			product.fields.shortDescription = variant.fields.shortDescription;
		}
		// if (variant.fields.name !== undefined) {
		// 	product.fields.title = variant.fields.name;
		// }
		if (variant.fields.deliveryFormat === "Webinar") {
			product.fields.courseStartDate = variant.fields?.courseStartDate || null;
			product.fields.timezone = variant.fields?.timezone || null;
		}
		delete product.variants;
		delete product.metadata;

		return product;
	});

	return products;
}

export function daysToMembershipExpire(profile) {
	const now = new Date().getTime();
	const oneDay = 1000 * 60 * 60 * 24;
	// const _30Days = oneDay * 30;
	// const _60Days = oneDay * 60;
	// const _90Days = oneDay * 90;

	//should the user renew?
	const renewalDate = profile.membershipRenewalDate ? new Date(profile.membershipRenewalDate).getTime() : false;

	if (!renewalDate) return Infinity;
	const timeToExpire = renewalDate - now;
	const daysToExpire = Math.ceil(timeToExpire / oneDay);
	return daysToExpire;
}

export function scrollTo(element, offset = 0) {
	if (!element) return;
	const elementPosition = element.getBoundingClientRect().top;
	const offsetPosition = elementPosition + window.pageYOffset - offset;
	window.scrollTo({
		top: offsetPosition,
		behavior: "smooth",
	});
}

//ALC data
export const ALC_DATA = {
	year: "2025",
	priceDates: {
		//  (8/28/23 - 1/4/2024)
		// previewPrice: "4/12/2024",
		earlyBird: "1/10/2025",
		//(01/5/2024 - 3/14/2024)
		regular: "3/27/2025",
		// (3/14/2024 - )
		late: "",
	},
	preConfCourse: {
		variablePrices: {
			member: {
				//  (8/28/23 - 1/4/2024)
				// previewPrice: 1099,
				// earlyBird: 574,
				//(01/5/2024 - 3/14/2024)
				// regular: 676,
				//(3/14/2024 - )
				// late: 743,
			},
			nonMember: {
				//  (8/28/23 - 1/4/2024)
				// previewPrice: 1399,
				// earlyBird: 676,
				//(01/5/2024 - 3/14/2024)
				// regular: 795,
				//(3/14/2024 - )
				// late: 875,
			},
			// joinNow: {
			// 	//  (8/28/23 - 1/4/2024)
			// 	earlyBird: 1249,
			// 	//(01/5/2024 - 3/14/2024)
			// 	regular: 1699,
			// 	//(3/14/2024 - )
			// 	late: 2049,
			// },
		},
	},
	variablePrices: {
		member: {
			//  (8/28/23 - 1/4/2024)
			// previewPrice: 1099,
			earlyBird: 1399,
			//(01/5/2024 - 3/14/2024)
			regular: 1799,
			//(3/14/2024 - )
			late: 2299,
		},
		nonMember: {
			// previewPrice: 1399,
			//  (8/28/23 - 1/4/2024)
			earlyBird: 1699,
			//(01/5/2024 - 3/14/2024)
			regular: 2099,
			//(3/14/2024 - )
			late: 2499,
		},
		joinNow: {
			//  (8/28/23 - 1/4/2024)
			earlyBird: 1549,
			//(01/5/2024 - 3/14/2024)
			regular: 1949,
			//(3/14/2024 - )
			late: 2349,
		},
	},
};
